import actionCreatorFactory from "typescript-fsa";
import { CommonAsyncType } from "../../core/types";
import { CommercialListRequestBody, CommercialListResponse } from "../../core/api/request/property/commercial/types";
import { PropertyDetailRequestBody, PropertyDetailResponse } from "../../core/api/request/property/details/types";
import { ResidentialListRequestBody, ResidentialListResponse } from "../../core/api/request/property/residential/types";

const actionCreator = actionCreatorFactory("@@Property");

export const propertyActions = {
    getCommercialList: actionCreator.async<CommonAsyncType<CommercialListResponse> & CommercialListRequestBody, CommercialListResponse>("COMMERCIAL_LIST"),
    getResidentailList: actionCreator.async<CommonAsyncType<ResidentialListResponse> & ResidentialListRequestBody, ResidentialListResponse>("RESIDENTIAL_LIST"),
    propertyDetail: actionCreator.async<CommonAsyncType<PropertyDetailResponse> & PropertyDetailRequestBody, PropertyDetailResponse>("PROPERTY_DETAIL"),
    resetToIntialState: actionCreator("RESET_TO_INITIAL_STATE"),
}
